<div class="shipping-label-popup__wrapper">
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</div>
